import PubSub from "pubsub-js";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ListingFourUpImageCardsLight = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingFourUpImageCardsLight',
	};

	$.extend(true, this.options, options);

};

ListingFourUpImageCardsLight.prototype.init = function() {

	var self = this;

	// equalize heading heights
	this.cardEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__cardNumberWrap`) );

	this.cardEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.cardEq.equalizeHeights();
	});

};

export default ListingFourUpImageCardsLight;
